import React, { Component, Fragment } from "react";
import axios from "../../../containers/api";
//import { Row, Card, CardBody, CardTitle, Button, Collapse, FormGroup, Label, Input, Badge, Modal, ModalBody, ModalHeader } from "reactstrap";
import { Row, Card, CardBody, CardTitle, Button, ModalBody, Modal, ModalHeader, Collapse, FormGroup, Label, Input, Badge, CustomInput  } from "reactstrap";
import { Colxx, Separator} from "../../../components/common/CustomBootstrap";
import {Table} from "../../../components/table/Table";
import DatePicker, { utils } from "react-modern-calendar-datepicker";
import Config from "../../../constants/config";
import { convertDate, getDayBefore, showCatchError, toEnglishNumbers, getkalas } from "../../../helpers/Utils";
 
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import PrintDriverReserve from "../../../components/print/PrintDriverReserve";
import { Checkbox, Radio } from "@mui/material";
import DriverReserveComment from "./DriverReserveComment";
export default class Reserve extends Component {
    constructor(props) {
        super(props);
        this.fileUploader = React.createRef();
        this.state = {
            fromDate: getDayBefore(),
            toDate: utils("fa").getToday(),
            member: JSON.parse(localStorage.getItem("member")),
            DriverCardNumber: "",
            FreighterCardNumber: "",
            collapse: true,
            reserveId: 0,
            driverId: 0,
            reservesSearchResult: [],
            StatusSearchTypes: [
               
                {value: 0, text: 'لغو شده'},
                {value: 1, text: 'رزرو بار'},
                {value: null, text: 'همه'},
             
            ],
            selectedStatusSearchType: { value: null, text: 'همه' },
            searchTitle: "", 
            selectedSenderLists: null,
            CustomerList: [],
            selectedReceiverLists: null,
            kala: null, 
            kalas: [],
            TransportationCompanyList: [],
            TransportationCompany: null,
            
            RateModal: false,
            SendCodeModal: false,
            DriverReserveCommentModal: false,
            Comment: "",
            ShowDriverReserveCommentModal: false  ,
            FileUploadModal: false,
            ShowFileUploadModal: false,
            Type: [
                { value: 0, text: 'حواله' },
                { value: 1, text: 'بانامه' },
                { value: -1, text: 'انتخاب کنید' }
            ],
            selectedType: { value: -1, text: 'انتخاب کنید' },
            DriverReserveUploadList: [],
            CommentLists: [],
            file: null, //uploaded picture
            RateType: 1,
            Desc:"",
            ActiveCode:"",
        };
    }

    componentDidMount() {
        this.searchReserves();
       
        if (this.props.memberType.role === 'AdminSupport' ||this.props.memberType.role === 'Driver' || this.props.memberType.role === 'Admin' || this.props.memberType.role === 'Organization' || this.props.memberType.role === 'DriversAssociation' || this.props.memberType.role === 'AssociationTransportCompanies')
        {
            this.GetAllTransportationCompany();
            this.GetAllCustomer();
        }
        else
            this.GetCustomerByTransportationCompanyId();
        try {
            this.getkalasApi().then(r => console.log(r));
        } catch (err) {
            console.log(err);
        }
    }
    async getkalasApi() {
        try {
            await getkalas()
                .then((res) => this.setState({ kalas: res.data }));
        } catch (err) {
            this.props.showAlert(showCatchError(err), "error");
        }
    }
    //checkPermission = () => {
    //    this.props.showSpinner();
    //    axios.get('api/ClientApi/HasAccessTo?permissionName=Reserve_List')
    //        .then((res) => {
    //            if (res.data) {
    //                this.searchReserves();
                  
    //                if (this.state.member.memberType === 'TransportationCompanyAdmin' || this.state.member.memberType === 'TransportationCompanyMember') {
    //                    this.GetCustomerByTransportationCompanyId();
                     
    //                }  
    //            } else {
    //                this.props.history.push('/error404');
    //            }
    //        })
    //        .catch((error) => {
    //            this.props.hideSpinner();
    //            this.props.showAlert(showCatchError(error), "error");
    //        });
    //};
    GetAllTransportationCompany = () => {
        let api = '';
        if (this.props.memberType.role === 'Organization' || this.props.memberType.role === 'DriversAssociation' || this.props.memberType.role === 'AssociationTransportCompanies')
            api = 'TransportationCompanyUser/GetByUserId'
        else
            api = 'TransportationCompany/GetAll'
        axios.get('/api/v1/' + api)
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ TransportationCompanyList: res.data.data });
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    searchReserves = () => {
        this.props.showSpinner();

        
        let model = {
            FromDate: convertDate(this.state.fromDate),
            ToDate: convertDate(this.state.toDate),
            DriverCardNumber: this.state.DriverCardNumber,
            FreighterCardNumber: this.state.FreighterCardNumber,
            DriverReserveStatus: this.state.selectedStatusSearchType.value!==null? toEnglishNumbers(this.state.selectedStatusSearchType.value):null,
            ReceiverCustomerId: this.state.selectedReceiverLists !== null ? this.state.selectedReceiverLists.id : null,
            SenderCustomerId: this.state.selectedSenderLists !== null ? this.state.selectedSenderLists.id : null, 
            KalaId: this.state.kala !== null ? this.state.kala.id : null,
            TransportationCompanyId: null,
        }
        if (this.props.memberType.role === 'AdminSupport' || this.props.memberType.role === 'Admin' || this.props.memberType.role === 'Organization' || this.props.memberType.role === 'DriversAssociation' || this.props.memberType.role === 'AssociationTransportCompanies')
            model.TransportationCompanyId = (this.state.TransportationCompany !== null && this.state.TransportationCompany !== undefined) ? this.state.TransportationCompany.transportationCompanyId : null
        axios.post('/api/v1/DriverReserve/SearchDriverReserve', model)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data.length > 0) {
                   
                    this.setState({
                        reservesSearchResult: res.data.data,
                        collapse: false,
                       
                    });
                } else {
                    this.setState({reservesSearchResult: []});
                    this.props.showAlert('رزروی یافت نشد.', "warning");
                }
            })
            .catch((error) => {
                console.log(error)
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    };

   
        GetCustomerByTransportationCompanyId = () => {
            axios.get('/api/v1/Customer/GetCustomerByTransportationCompanyId')
                .then((res) => {
                    this.props.hideSpinner();
                    this.setState({ CustomerList: res.data.data });
                })
                .catch((error) => {
                    this.props.hideSpinner();
                    console.log(error.response);
                    this.props.showAlert(showCatchError(error), "error");
                });
        };
    Print = (Id) => {
        this.printChild.Report_DriverReserve(Id);
        this.searchReserves();
    }
    GetAllCustomer = () => {
        axios.get('/api/v1/Customer/GetAllCustomer')
                .then((res) => {
                    this.props.hideSpinner();
                    this.setState({ CustomerList: res.data.data });
                })
                .catch((error) => {
                    this.props.hideSpinner();
                    console.log(error.response);
                    this.props.showAlert(showCatchError(error), "error");
                });
        };
   
    
    resetSearch = () => {
        this.setState({
            fromDate: getDayBefore(),
            toDate: utils("fa").getToday(),
            DriverCardNumber: "",
            FreighterCardNumber: "",
            selectedStatusSearchType: { value: null, text: 'همه' },
            selectedReceiverLists: null, 
            selectedSenderLists: null,
            kala: null, 
            
        });
        if (this.props.memberType.role === 'AdminSupport' || this.props.memberType.role === 'Admin' || this.props.memberType.role === 'Organization' || this.props.memberType.role === 'DriversAssociation' || this.props.memberType.role === 'AssociationTransportCompanies') {
            this.setState({
                TransportationCompany: null,
            })
        }
    }
    async getkalasApi() {
        try {
            await getkalas()
                .then((res) => this.setState({ kalas: res.data }));
        } catch (err) {
            this.props.showAlert(showCatchError(err), "error");
        }
    }

   
    CancelReserve = (Id) => { 
        this.props.showSpinner();
        let model = {
            Id:Id,
            CancelType: this.props.memberType.role === 'Driver'?false:true, 
        }

        axios.post('/api/v1/DriverReserve/CancelReserve', model) 
            .then((res) => {
                this.props.hideSpinner();
                this.props.closeSweetAlert();
                this.searchReserves();
                this.props.showAlert(res.data.data.message, "success");
            })
            .catch((error) => {
                this.props.closeSweetAlert();
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    ReturnTurn = (Id, DriverToFreighterId) => { 
        this.props.showSpinner();
        let model = {
            Item1:Id,
            Item2: DriverToFreighterId,
            
        }

        axios.post('/api/v1/DriverTurn/ReturnTurn', model) 
            .then((res) => {
                this.props.hideSpinner();
                this.props.closeSweetAlert();
                this.searchReserves();
                this.props.showAlert(res.data.data.message, "success");
            })
            .catch((error) => {
                this.props.closeSweetAlert();
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    };
  
    ReportReserve = (reserveId, format) => {
        let postData = {
            responseType: "arraybuffer"
        }

        this.props.showSpinner();
        axios.get('api/v1/Report/DriverReserveReport?DriverReserveId=' + reserveId + '&Format=' + format, postData)
            .then((res) => {
                this.props.hideSpinner();
                if (format === 'pdf') {
                    let blob = new Blob([res.data], {type: "application/pdf"});
                    let objectUrl = URL.createObjectURL(blob);
                    window.open(objectUrl);
                    this.searchReserves();
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                let decoder = new TextDecoder("utf-8");
                if (error.response != null) {
                    let domString = decoder.decode(error.response.data);
                    if (domString !== null && domString.trim() !== "" && domString.trim() !== undefined) {
                        let msg = domString.replace("-", " ");
                        let msg1 = msg.replace('"', ' ');
                        let msg2 = msg1.replace('"', ' ');
                        this.props.showAlert(msg2, "error");
                    } else {
                        this.props.showAlert("در چاپ خطايی رخ داده است", "error");
                    }
                } else {
                    this.props.showAlert("در چاپ خطايی رخ داده است", "error");
                }
            });
    };

    
    

    closeModal = (modalName) => {
        this.setState({ [modalName]: false });
        if (modalName === 'SendCodeModal')
            this.searchReserves();
    };

    selectHandleChange = (event, value, name) => {
        this.setState({[name]: value });
    };
    reset = () => {
        this.setState({

            selectedType: { value: -1, text: 'انتخاب کنید' },
            file: null
        })
    }
    GetByDriverReserveId = (DriverReserveId) => {
        this.props.showSpinner();
        axios.get('/api/v1/FileUpload/GetByDriverReserveId?DriverReserveId=' + DriverReserveId)
            .then((res) => {
                this.props.hideSpinner();
                if (res.status === 200) {
                    if (res.data.data.length != null && res.data.data.length > 0) {
                        this.setState({ DriverReserveUploadList: res.data.data, DriverReserveMsg: "" });
                        //console.log(res.data.data);
                    } else {
                        this.setState({ DriverReserveUploadList: [], DriverReserveListMsg: "درخواستی وجود ندارد" });
                    }
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error));
                console.log(error.response);
            });
    };
    UploadFile = () => {
        if (this.state.selectedType.value === -1) {
            this.props.showAlert("لطفا نوع مدرک را انتخاب کنید")
        }
        else if (this.state.file === null) {
            this.props.showAlert("لطفا فایل مورد نظر را انتخاب کنید")
        }
        else {
            this.props.showSpinner();
            let result = "";
            switch (this.state.selectedType.value) {
                case 0:
                    result ="draft" ;
                    break;
                case 1:
                    result = "bill";
                    break;
                
                default:
            }
            let model = new FormData();
            model.set('FileName', result);
            model.set('Type', toEnglishNumbers(this.state.selectedType.value),);
            model.set('DriverReserveId', this.state.DriverReserveId);
            model.append('File', this.state.file);

            axios.post('/api/v1/FileUpload/AddFileUpload', model, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((res) => {
                this.props.hideSpinner();
                console.log(res.data.data)
                if (res.data.data === null) {
                    this.props.showAlert(res.data.data.message, "error");
                }
                else {
                    this.setState({ FileUploadModal: false });
                    this.props.showAlert(res.data.data.message, "success");
                    this.searchReserves();
                }

            }).catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
        }
    };
    RegisterRate = () => {
        const addModel = {
            Rate: this.state.RateType,
            Desc: this.state.Desc,
            DriverReserveId: this.state.DriverReserveId
        };

        this.props.showSpinner();
        axios.post('api/v1/DriverRate/AddDriverRate', addModel)
            .then((res) => {
                this.props.hideSpinner();
                if (res.status === 200) {
                    this.props.showAlert(res.data.data.message, "success");
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
     SendActivatinCode = () => {
        
        this.props.showSpinner();
         axios.post('api/v1/Assistant/DriverReserveSendActivatinCode?DriverReserveId=' + this.state.DriverReserveId)
            .then((res) => {
                this.props.hideSpinner();
                if (res.status === 200) {
                    this.props.showAlert(res.data.data.message, "success");

                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
    CheckActivatin = () => {
        if (this.state.ActiveCode === null || this.state.ActiveCode === "" || this.state.ActiveCode === '') {
            this.props.showAlert("لطفا کد ارسالی را وارد کنید")
        }
        else {
            this.props.showSpinner();
            const addModel = {

                code: this.state.ActiveCode,
                DriverReserveId: this.state.DriverReserveId
            };

            this.props.showSpinner();
            axios.post('api/v1/Assistant/CheckActivatinForUpdateReserveStatus', addModel)
                .then((res) => {
                    this.props.hideSpinner();
                    if (res.status === 200) {
                        this.props.showAlert(res.data.data.message, "success");
                        
                    }
                })
                .catch((error) => {
                    this.props.hideSpinner();
                    this.props.showAlert(showCatchError(error), "error");
                    console.log(error.response);
                });
        }
    };
    GetDriverReserveCommentByDriverReserveId = (DriverReserveId) => {
        this.props.showSpinner();
        axios.get('api/v1/DriverReserveComment/GetDriverReserveCommentByDriverReserveId?DriverReserveId=' + DriverReserveId)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data !== null)
                    this.setState({ CommentLists: res.data.data });
                else
                    this.setState({ alertText: res.data.errors, loginAlert: true, loading: false });
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
    render() {
        const {collapse, toDate, fromDate, DriverCardNumber, FreighterCardNumber, reservesSearchResult} = this.state;

        return (

            <Fragment>
                <PrintDriverReserve
                    onRef={ref => (this.printChild = ref)}
                    showSpinner={this.props.showSpinner}
                    hideSpinner={this.props.hideSpinner}
                    showAlert={this.props.showAlert}
                />
                                <Row>
                    <Colxx xxs="12">
                        <h3> لیست بارهای انتخاب شده</h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>
                <Row>
                    <Colxx xxs="12" className="mb-4">
                        <Card>
                            <CardBody>
                            <CardTitle>جستجو</CardTitle> 

                                    <div className="p-4 pt-5 border d-flex flex-column">
                                        <div className="d-flex flex-md-row flex-column justify-content-between">
                                            <FormGroup className="w-md-25 w-100 px-1">
                                                <Label>از تاریخ</Label>
                                                <DatePicker
                                                    value={fromDate}
                                                    onChange={(newDate) => {this.setState({fromDate: newDate});}}
                                                    inputPlaceholder="لطفا یک تاریخ انتخاب کنید"
                                                    shouldHighlightWeekends
                                                    inputClassName="form-control"
                                                    locale="fa"
                                                    calendarClassName="calendar"
                                                    colorPrimary={Config.color}
                                                    calendarPopperPosition={'bottom'}
                                                />
                                            </FormGroup>

                                            <FormGroup className="w-md-25 w-100 px-1">
                                                <Label>تا تاریخ</Label>
                                                <DatePicker
                                                    value={toDate}
                                                    onChange={(newDate) => {this.setState({toDate: newDate});}}
                                                    inputPlaceholder="لطفا یک تاریخ انتخاب کنید"
                                                    shouldHighlightWeekends
                                                    inputClassName="form-control"
                                                    locale="fa"
                                                    calendarClassName="calendar"
                                                    colorPrimary={Config.color}
                                                    calendarPopperPosition={'bottom'}
                                                />
                                            </FormGroup>
                                        <FormGroup className="w-md-25 w-100 px-1">
                                            <Label>نوع محموله</Label>
                                            <Autocomplete
                                                clearText={"حذف"}
                                                closeText={"بستن"}
                                                noOptionsText={"در حال دریافت اطلاعات.."}
                                                openText={"باز کردن"}
                                                className="react-select__control"
                                                id="kala"
                                                options={this.state.kalas}
                                                getOptionLabel={(option) => option.kalaDesc}
                                                value={this.state.kala}
                                                onChange={(e, v) => this.selectHandleChange(e, v, "kala")}
                                                renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                            />
                                        </FormGroup>
                                        </div>
                                            <div className="d-flex flex-md-row flex-column justify-content-between">

                                        {this.props.memberType.role !== 'Driver' &&
                                            <FormGroup className="w-md-25 w-100 px-1">
                                                <Label>وضعیت</Label>
                                                <Autocomplete
                                                    disableClearable
                                                    clearText={"حذف"}
                                                    closeText={"بستن"}
                                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                                    openText={"باز کردن"}
                                                    className="react-select__control"
                                                    id="selectedStatusSearchType"
                                                    options={this.state.StatusSearchTypes}
                                                    getOptionLabel={(option) => option.text}
                                                    value={this.state.selectedStatusSearchType}
                                                    onChange={(e, v) => this.selectHandleChange(e, v, "selectedStatusSearchType")}
                                                    renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                                />
                                            </FormGroup>
                                        }
                                        {this.props.memberType.role !== 'Driver' &&
                                            <FormGroup className="w-md-25 w-100 px-1">
                                                <Label>فرستنده</Label>
                                                <Autocomplete
                                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                                    openText={"باز کردن"}
                                                    className="react-select__control"
                                                    id="selectedSenderLists"
                                                    options={this.state.CustomerList}
                                                    getOptionLabel={(option) => option.customerFullName + ' (' + option.meliCode + ')'}
                                                    value={this.state.selectedSenderLists}
                                                    onChange={(e, v) => this.selectHandleChange(e, v, "selectedSenderLists")}
                                                    renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                                />
                                            </FormGroup>
                                        }
                                        {this.props.memberType.role !== 'Driver' &&
                                            <FormGroup className="w-md-25 w-100 px-1">
                                                <Label>گیرنده</Label>
                                                <Autocomplete
                                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                                    openText={"باز کردن"}
                                                    className="react-select__control"
                                                    id="selectedReceiverLists"
                                                    options={this.state.CustomerList}
                                                    getOptionLabel={(option) => option.customerFullName + ' (' + option.meliCode + ')'}
                                                    value={this.state.selectedReceiverLists}
                                                    onChange={(e, v) => this.selectHandleChange(e, v, "selectedReceiverLists")}
                                                    renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                                />
                                            </FormGroup>
                                        }
                                            

                                           
                                        </div>
                                    <div className="d-flex flex-md-row flex-column justify-content-between">
                                        {this.props.memberType.role !== 'Driver' &&
                                        <FormGroup className="w-md-25 w-100 px-1">
                                            <Label>شماره هوشمند راننده</Label>
                                            <Input value={DriverCardNumber} onChange={(e) => this.setState({ DriverCardNumber: e.target.value })} />
                                        </FormGroup>
                                        }
                                        {this.props.memberType.role !== 'Driver' &&
                                        <FormGroup className="w-md-25 w-100 px-1">
                                            <Label>شماره هوشمند ناوگان</Label>
                                            <Input value={FreighterCardNumber} onChange={(e) => this.setState({ FreighterCardNumber: e.target.value })} />
                                        </FormGroup>
                                        
                                        }
                                        <FormGroup className="w-md-25 w-100 px-1">
                                        </FormGroup>
                                        </div>
                                        {(this.props.memberType.role === 'AdminSupport' || this.props.memberType.role === 'Admin' || this.props.memberType.role === 'Organization' || this.props.memberType.role === 'DriversAssociation' || this.props.memberType.role === 'AssociationTransportCompanies') &&
                                            <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap">
                                                <FormGroup className="w-md-30 w-100 px-1">
                                                    <Label>شركت های حمل و نقل</Label>
                                                    <Autocomplete
                                                        clearText={"حذف"}
                                                        closeText={"بستن"}
                                                        noOptionsText={"در حال دریافت اطلاعات.."}
                                                        openText={"باز کردن"}
                                                        className="react-select__control"
                                                        id="TransportationCompany"
                                                        options={this.state.TransportationCompanyList}
                                                        getOptionLabel={(option) => option.transportationCompanyName}
                                                        value={this.state.TransportationCompany}
                                                        onChange={(e, v) => this.selectHandleChange(e, v, "TransportationCompany")}
                                                        renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                                    />
                                                </FormGroup>
                                            </div>
                                        }
                                        <div className="d-flex mt-2 justify-content-center">
                                            <FormGroup className="text-center">
                                                <Button color="primary" className="btn-lg mx-2" onClick={this.searchReserves}>
                                                    جستجو
                                                </Button>
                                            </FormGroup>
                                            <FormGroup className="text-center">
                                                <Button color="primary" className="btn-lg mx-2" onClick={this.resetSearch}>
                                                    پاک کردن
                                                </Button>
                                            </FormGroup>
                                        </div>
                                    </div>

                                {this.state.searchTitle !== "" ?
                                    <CardTitle className="d-flex w-100 justify-content-md-start justify-content-center mt-5"> نتایج جستجو ({this.state.searchTitle})</CardTitle>
                                    :
                                    null
                                }

                                {reservesSearchResult ?
                                    <Table
                                        tableHeaders={[
                                            "شناسه",
                                            "شناسه بار",
                                            "وضعیت",
                                            "شركت حمل و نقل", 
                                            "نام راننده",
                                            "موبایل",
                                            "هوشمند راننده",
                                            "هوشمند ماشين",
                                            "پلاک", 
                                            "محموله", 
                                            "لغو", 
                                            "چاپ رزرو",
                                            "امتیاز دهی",
                                            "بارگزاری مدارک",
                                            "نمایش مدارک",
                                            "تحویل بار",
                                            "ثبت نظر",
                                            "نمایش نظر",
                                        ]}

                                        tableRow={this.state.reservesSearchResult}

                                        tableData={[
                                            reserve => {
                                                return reserve.id;
                                            },
                                            reserve => {
                                                return reserve.cargoId;
                                            },
                                            reserve => {
                                                switch (reserve.status) {
                                                    case 0:
                                                        return <Badge color="outline-danger" pill>باطل شده</Badge>;
                                                    case 1:
                                                        return <Badge color="outline-warning" pill>رزرو بار</Badge>;
                                                    case 2:
                                                        return <Badge color="outline-warning" pill>چاپ رزرو </Badge>;
                                                    case 3:
                                                        return <Badge color="outline-warning" pill> بارگذاری حواله </Badge>;
                                                    case 4:
                                                        return <Badge color="outline-warning" pill> بارگذاری بارنامه </Badge>;
                                                    case 5:
                                                        return <Badge color="outline-warning" pill> تحویل بار </Badge>;
                                                    case 6:
                                                        return <Badge color="outline-warning" pill> تکمیل بارگیری </Badge>;
                                                     
                                                }
                                            },
                                            reserve => {
                                                return reserve.transportationCompanyName !== null && reserve.transportationCompanyName;
                                            },                                            
                                            

                                            reserve => {
                                                return reserve.driverName + " " + reserve.driverFamily;
                                            },
                                            reserve => {
                                                return reserve.driverMobile;
                                            },
                                            reserve => {
                                                return reserve.driverCardNumber;
                                            },
                                            reserve => {
                                                return reserve.freighterCardNumber;
                                            },
                                            reserve => {
                                                return reserve.plaque  
                                            },
                                             
                                            reserve => {
                                                return reserve.kalaDesc;
                                            },
                                             
                                            reserve => {
                                                if (reserve.status === 1 && reserve.driverTurnId === null && this.props.memberType.role !== 'Organization' && this.props.memberType.role !== 'DriversAssociation' && this.props.memberType.role !== 'AssociationTransportCompanies' ) {
                                                    return (
                                                        <Button outline color="primary" size="sm"
                                                            onClick={() => this.props.showSweetAlert("آیا این رزرو باطل شود؟", "", "danger", () => this.CancelReserve(reserve.id))}>
                                                            لغو
                                                        </Button>
                                                    )
                                                }
                                            },
                                            reserve => {
                                                if (this.props.memberType.role !== 'Driver') {
                                                    return (
                                                        (reserve.status !== 0) &&
                                                        <Button outline color="info" size="sm"
                                                            onClick={() => this.Print(reserve.id)}>

                                                            چاپ رزرو
                                                        </Button>
                                                    );
                                                }
                                            },
                                            reserve => {
                                                if (this.props.memberType.role !== 'Driver') {
                                                    return (
                                                        <Button outline color="success" className="mx-3 my-md-0 my-1"
                                                            onClick={() => this.setState({ RateModal: true, DriverReserveId: reserve.id, Desc: "", RateType: 1 })}>
                                                            امتیازدهی
                                                        </Button>


                                                    )
                                                }

                                            },
                                            reserve => {
                                              /*  if (this.props.memberType.role !== 'Driver') {*/
                                                    return (
                                                        <Button outline color="primary" size="sm"
                                                            onClick={() => this.setState({ DriverReserveId: reserve.id, FileUploadModal: true }, () => this.reset()
                                                            )}>
                                                            بارگزاری مدارک
                                                        </Button>

                                                    )
                                                //}
                                            },
                                            reserve => {
                                                return (
                                                    <Button outline color="primary" size="sm"
                                                        onClick={() => this.setState({ ShowFileUploadModal: true }, () => this.GetByDriverReserveId(reserve.id)
                                                        )}>
                                                        نمایش مدارک
                                                    </Button>

                                                )
                                            },
                                            reserve => {
                                                if (reserve.status !== 5 && this.props.memberType.role === 'Driver') {
                                                    return (
                                                        <Button outline color="success" className="mx-3 my-md-0 my-1"
                                                            onClick={() => this.setState({ SendCodeModal: true, DriverReserveId: reserve.id  })}>
                                                           تحویل بار
                                                        </Button>


                                                    )
                                                }

                                            },
                                            
                                             
                                            reserve => {
                                                if (this.props.memberType.role === 'Driver') {
                                                    return (
                                                        <Button outline color="success" className="mx-3 my-md-0 my-1"
                                                            onClick={() => this.setState({ DriverReserveCommentModal: true, DriverReserveId: reserve.id, Comment: "" })}>
                                                            ثبت نظر
                                                        </Button>


                                                    )
                                                }

                                            },
                                            reserve => {
                                              
                                                    return (

                                                        <Button outline color="primary" size="sm"
                                                            onClick={() => this.setState({ ShowDriverReserveCommentModal: true }, () => this.GetDriverReserveCommentByDriverReserveId(reserve.id)
                                                            )}>
                                                            نمایش نظر
                                                        </Button>

                                                    )
                                                


                                            },


                                        ]}
                                    />
                                    :
                                    null
                                }
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>


                <Modal isOpen={this.state.RateModal} size="xlg" toggle={() => this.closeModal("RateModal")}>
                    <ModalHeader toggle={() => this.closeModal("RateModal")}>
                       امتیازدهی
                    </ModalHeader>
                    <ModalBody>
                        <div className="d-flex flex-md-row flex-column flex-wrap justify-content-around align-items-center w-25">
                            <CustomInput
                                lassName="w-md-20 w-50"
                                type="radio"
                                id="RateType1"
                                name="RateType"
                                label="1"
                                checked={this.state.RateType === 1}
                                onChange={() => this.setState({ RateType: 1  })}
                            />
                            <CustomInput
                                lassName="w-md-20 w-50"
                                type="radio"
                                id="RateType2"
                                name="RateType"
                                label="2"
                                checked={this.state.RateType === 2}
                                onChange={() => this.setState({ RateType: 2  })}
                            />
                            <CustomInput
                                lassName="w-md-20 w-50"
                                type="radio"
                                id="RateType3"
                                name="RateType"
                                label="3"
                                checked={this.state.RateType === 3}
                                onChange={() => this.setState({ RateType: 3  })}
                            />
                            <CustomInput
                                className="w-md-20 w-50"
                                type="radio"
                                id="RateType4"
                                name="RateType"
                                label="4"
                                checked={this.state.RateType === 4}
                                onChange={() => this.setState({ RateType: 4  })}
                            />
                            <CustomInput
                                className="w-md-20 w-50"
                                type="radio"
                                id="RateType5"
                                name="RateType"
                                label="5"
                                checked={this.state.RateType === 5}
                                onChange={() => this.setState({ RateType: 5  })}
                            />
                        </div>
                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>توضیحات</Label>
                        <Input value={this.state.Desc} 
                                onChange={(e) => this.setState({ Desc: e.target.value })}/>
                    </FormGroup> 
                    <FormGroup className="w-md-30 w-100 px-1">

                        <Button color="primary" className="btn-lg mx-2"
                                onClick={() =>   this.RegisterRate()}>
                            ثبت امتیاز
                        </Button>
                    </FormGroup> 
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.FileUploadModal} toggle={() => this.setState({ FileUploadModal: false })} size="xlg">
                    <ModalHeader toggle={() => this.setState({ FileUploadModal: false })}>
                        {this.state.DriverReserveMsg}
                    </ModalHeader>
                    <ModalBody className="d-flex flex-md-row flex-column justify-content-center align-items-end flex-wrap w-100 mt-5">

                        <div className="p-4 pt-5 border d-flex flex-column">
                            <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap">

                                <FormGroup className="w-md-100 w-100 px-1">
                                    <Label>نوع مدرک</Label>
                                    <Autocomplete
                                        disableClearable
                                        clearText={"حذف"}
                                        closeText={"بستن"}
                                        noOptionsText={"در حال دریافت اطلاعات.."}
                                        openText={"باز کردن"}
                                        className="react-select__control"
                                        id="selectedType"
                                        options={this.state.Type}
                                        getOptionLabel={(option) => option.text}
                                        value={this.state.selectedType}
                                        onChange={(e, v) => this.selectHandleChange(e, v, "selectedType")}
                                        renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                    />

                                </FormGroup>



                            </div>

                            <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap">


                                <FormGroup className="w-md-25 w-100 mx-1">
                                    <label className="form-title">
                                        تصویر</label>

                                    <input
                                        style={{ cursor: "cell" }}
                                        className="input" value={this.state.file !== null ? this.state.file.name : "لطفا یک فایل انتخاب کنید"}
                                        onClick={() => this.fileUploader.current.click()} />
                                    <input
                                        ref={this.fileUploader}
                                        style={{ display: "none" }} type="file"
                                        onChange={(e) => {
                                            this.setState({ file: e.target.files[0] });
                                        }}
                                    />
                                </FormGroup>
                            </div>

                            <div className="d-flex mt-2 justify-content-center">
                                <FormGroup className="text-center">
                                    <Button color="primary" className="btn-lg mx-2" onClick={this.UploadFile}>
                                        ثبت
                                    </Button>
                                </FormGroup>

                            </div>
                        </div>


                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.ShowFileUploadModal} toggle={() => this.setState({ ShowFileUploadModal: false })} size="xlg">
                    <ModalHeader toggle={() => this.setState({ ShowFileUploadModal: false })}>
                        {this.state.DriverReserveListMsg}
                    </ModalHeader>
                    <ModalBody className="d-flex justify-content-center">

                        <Table
                            tableHeaders={[
                                "نوع",
                                "تاریخ ثبت",
                                "ساعت ثبت",
                                "مدرک",

                            ]}

                            tableRow={this.state.DriverReserveUploadList}

                            tableData={[
                                x => {
                                    switch (x.type) {

                                        case 0:
                                            return <Badge color="outline-danger" pill>بانامه</Badge>
                                        case 1:
                                            return <Badge color="outline-secondary" pill>حواله</Badge>
                                       
                                    }
                                },
                                x => {
                                    return x.date
                                },
                                x => {
                                    return x.time
                                },
                                x => {
                                    return <a target="_blank"
                                        href={Config.url + "UploadFile/" + toEnglishNumbers(x.fileName)}><img
                                            alt="" width="50px" height="50px"
                                            src={Config.url + "UploadFile/" + toEnglishNumbers(x.fileName)} /></a>;
                                },
                            ]} />


                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.SendCodeModal} size="xlg" toggle={() => this.closeModal("SendCodeModal")}>
                    <ModalHeader toggle={() => this.closeModal("SendCodeModal")}>
                      تحویل بار
                    </ModalHeader>
                    <ModalBody>
                        <FormGroup className="w-md-30 w-100 px-1">
                        <Button color="primary" className="btn-lg mx-2"
                            onClick={() => this.SendActivatinCode()}>
                           ارسال كد
                            </Button>
                        </FormGroup>
                        <FormGroup className="w-md-30 w-100 px-1">
                            <Label>کد</Label>
                            <Input value={this.state.ActiveCode}
                                onChange={(e) => this.setState({ ActiveCode: e.target.value })} />
                        </FormGroup>
                        <FormGroup className="w-md-30 w-100 px-1">

                            <Button color="primary" className="btn-lg mx-2"
                                onClick={() => this.CheckActivatin()}>
                               تحویل بار
                            </Button>
                        </FormGroup>
                    </ModalBody>
                </Modal> 
                <Modal isOpen={this.state.DriverReserveCommentModal} size="xlg" toggle={() => this.closeModal("DriverReserveCommentModal")}>
                    <ModalHeader toggle={() => this.closeModal("DriverReserveCommentModal")}>
                        ثبت نظر
                    </ModalHeader>
                    <ModalBody>
                        <DriverReserveComment
                            isModal={true}

                            DriverReserveId={this.state.DriverReserveId}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                            showAlert={this.props.showAlert}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.ShowDriverReserveCommentModal} size="xlg" toggle={() => this.closeModal("ShowDriverReserveCommentModal")}>
                    <ModalHeader toggle={() => this.closeModal("ShowDriverReserveCommentModal")}>
                       نمایش نظر
                    </ModalHeader>
                    <ModalBody>
                        <Table
                            tableHeaders={[
                                
                                "متن نظر",
                                "تاريخ نظر",
                                "ساعت نظر",
                               /* "کد رهگیری",*/


                            ]}

                            tableRow={this.state.CommentLists}

                            tableData={[
                                
                                item => {
                                    return item.comment
                                },
                                item => {
                                    return item.date;
                                },
                                item => {
                                    return item.time;
                                },
                                //item => {
                                //    return item.trackingCode;
                                //},
                            ]} />
                    </ModalBody>
                </Modal>
 
                 
            </Fragment>
        )
    }
}
